<template>
  <div style="margin: 0 auto; max-width: 800px;">
    <div class="mt-3 ml-3 mr-3">
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>
      <p class="mt-3 mb-5 text-left link" @click="backToDashboard">Back to Dashboard</p>
      <div v-if="$store.state.isUserLoggedIn">
        <h1 style="font-size: 22px; text-align: center;">Your Orders</h1>
        <div style="height: 2px; width: 100%;background-color: black;" class="mb-3"></div>
      </div>

      <div
        v-for="(order) in this.orders"
        :key="order.id"
        style="padding: 0px; margin: 0 auto; max-width: 600px;"
      >
        <div
          v-for="(item) in order.purchasedItems"
          :key="item.id"
          style="padding: 0px; margin: 0 auto; max-width: 600px;"
        >
          <h4 style="text-align: center;" class="mb-3 mt-2">{{item.title}}</h4>
          <v-row no-gutters class="ml-5 mr-5 cartBox" style="text-align: center;">
            <v-col cols="12" sm="1" md="2" lg="2">
              <p>{{item.kind}}</p>
            </v-col>

            <v-col cols="12" sm="3" md="2" lg="2">
              <p>
                <span style="font-weight: bold;">Size:</span>
                {{item.size}}
              </p>
            </v-col>

            <v-col cols="12" sm="6" md="5" lg="5" class="mb-4">
              <v-btn
                class
                style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
              >Quantity: {{item.quantity}}</v-btn>
            </v-col>

            <v-col cols="12" sm="2" md="3" lg="3">
              <p>
                <span style="font-weight: bold;">Price:</span>
                ${{item.dollarAmount}}
              </p>
            </v-col>
          </v-row>
          <div style="height: 1px; width: 90%;background-color: grey; margin: 0 auto;" class="mb-2"></div>
        </div>
        <v-row style="text-align: center;">
          <v-col cols="12" sm="6">
            <p style="margin: 0px; padding: 0px;">
              <span style="font-weight: bold;">Order Date:</span>
              {{order.createdAt}}
            </p>
          </v-col>
          <v-col cols="12" sm="6">
            <p style="margin: 0px; padding: 0px;">
              <span style="font-weight: bold;">Total:</span>
              ${{order.total}}
            </p>
          </v-col>
        </v-row>

        <div style="height: 2px; width: 100%;background-color: black;" class="mb-2"></div>
        <div style="height: 2px; width: 100%;background-color: black;" class="mb-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data: () => ({
    error: "",
    orders: ""
  }),
  async mounted() {
    this.scrollToTop();
    try {
      const response = await UserService.orders();
      this.orders = response.data.orders;
      this.orders.forEach(order => {
        order.purchasedItems = JSON.parse(order.purchasedItems);
        order.total = order.total / 100;
        order.createdAt = order.createdAt.substring(0, 10);
      });
      console.log(this.orders);
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    changePasswordPage() {
      this.$router.push("/change-password");
    },
    addressBook() {
      this.$router.push("/addressBook");
    },
    backToDashboard() {
      this.$router.push("/dashboard");
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
